import { makeStyles } from '@material-ui/core';

export default makeStyles({
    containerBarra: {
        width: '100%',
    },

    barra: {
        height: 10,
        borderRadius: 5,
    },

    texto: {
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '-0.01em',
        color: '#011328',
    },
});
